import React from 'react';
import {
  useUpdateSalesforceContactFieldValueMutation,
  SalesforceContactField,
  SalesforceContact,
} from 'api';

interface Props {
  field: SalesforceContactField;
  salesforceContact: SalesforceContact;
}

const Name = ({field, salesforceContact}: Props) => {
  const value = salesforceContact.addition[`${field.fieldName}`];
  const [lastName, firstName] = value.split(' ');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [updateFieldValue] = useUpdateSalesforceContactFieldValueMutation({
    onCompleted: (data) => {
      setErrorMessage(data.updateSalesforceContactFieldValue.error);
    },
  });

  return (
    <>
      <input
        defaultValue={lastName}
        className="w-max"
        onBlur={(e) => {
          updateFieldValue({
            variables: {
              salesforceContactId: salesforceContact.id,
              attributes: {fieldName: 'lastName', value: e.target.value},
            },
          });
        }}
      />
      <input
        defaultValue={firstName}
        className="w-max"
        onBlur={(e) => {
          updateFieldValue({
            variables: {
              salesforceContactId: salesforceContact.id,
              attributes: {fieldName: 'firstName', value: e.target.value},
            },
          });
        }}
      />
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default Name;
